import React, { forwardRef } from 'react';
import { createTotalRow } from '../rows';
import { useGridContext, useGridToggleableContext } from '../features';
export var gridTotalId = 'grid-total-box';
var GridTotal = forwardRef(function (props, ref) {
    var _a = useGridContext().state, disabled = _a.disabled, rowHeight = _a.rowHeight, totalRow = _a.totalRow, isEmpty = _a.isEmpty, columnsWidth = _a.columnsWidth;
    var _b = useGridToggleableContext(), visibleColumns = _b.visibleColumns, rowWidth = _b.rowWidth;
    if (!totalRow) {
        return null;
    }
    return (React.createElement("div", { "data-selector-id": gridTotalId, style: {
            overflow: !isEmpty ? 'hidden' : 'auto',
            flexShrink: 0
        } },
        React.createElement("div", { style: {
                width: rowWidth,
                height: rowHeight
            }, ref: ref }, createTotalRow({
            columns: visibleColumns,
            columnsWidth: columnsWidth,
            data: totalRow,
            disabled: disabled
        }))));
});
export default GridTotal;
//# sourceMappingURL=GridTotal.js.map